import _ from 'underscore';
import Backbone from 'backbone';

export default Backbone.Model.extend({
    returnTreeColsById: function (nodeId) {
        var treeNodes = {
            n1: undefined,
            n2: undefined,
            n3: undefined
        };

        var id = parseInt(nodeId, 10);

        _.each(this.attributes, function (n1, nodeLevel1Key) { // eslint-disable-line consistent-return
            /*
             * Check node level 1
             */
            if (parseInt(nodeLevel1Key, 10) === id) {
                treeNodes.n1 = n1;

                return false;
            }

            _.each(n1.children, function (n2, nodeLevel2Key) { // eslint-disable-line consistent-return

                /*
                 * Check node level 2
                 */
                if (parseInt(nodeLevel2Key, 10) === id) {
                    treeNodes.n1 = n1;
                    treeNodes.n2 = n2;

                    return false;
                }

                _.each(n2.children, function (n3) { // eslint-disable-line consistent-return
                    if (n3.id === id) {
                        treeNodes.n1 = n1;
                        treeNodes.n2 = n2;
                        treeNodes.n3 = n3;

                        return false;
                    }
                });
            });
        });

        return treeNodes;
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc1/fttc1Model.js
 **/